import './bootstrap';
import '../css/app.css';

import { MantineProvider } from '@mantine/core';

import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';

import 'mantine-datatable/styles.layer.css';
import '@mantine/core/styles.layer.css';
import '@mantine/core/styles.css';

import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/code-highlight/styles.css';


const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.jsx`, import.meta.glob('./Pages/**/*.jsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <MantineProvider defaultColorScheme="light">
                <App {...props} />
            </MantineProvider>);
    },
});

InertiaProgress.init({ color: '#4B5563', showSpinner: true });
